// EditJobModal.tsx
import React, { useState } from 'react';
import { Job, JobUpsertParams } from '../../types/job';
import { useJobStore } from '../../stores/jobStore';
import { useTranslation } from 'react-i18next';
import FullBlockingModal from '../common/FullBlockingModal';
import EditJobForm from './EditJobForm';

interface EditJobModalProps {
  job: Job;
  onClose: () => void;
  onJobUpdated: () => void;
  onCancelChange: () => void;
}

const EditJobModal: React.FC<EditJobModalProps> = ({
  job,
  onClose,
  onJobUpdated,
  onCancelChange,
}) => {
  const { t } = useTranslation(['jobs', 'common']);
  const { upsertJob } = useJobStore();
  const [error, setError] = useState<string | null>(null);

  const handleUpdateJob = async (updatedParams: JobUpsertParams) => {
    try {
      await upsertJob(updatedParams, job.id);
      onJobUpdated();
    } catch (err) {
      console.error(err);
      setError(t('error.generic', { ns: 'common' }));
    }
  };

  return (
    <FullBlockingModal innerClassName="md:max-w-[72rem]">
      <button
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl md:top-0"
        onClick={onClose}
        aria-label={t('common:form_actions.close')}
      >
        &times;
      </button>
      <h2 className="text-2xl font-bold text-secondary mb-4">
        {t('edit_job_title', { ns: 'jobs', defaultValue: "Modifier l'offre" })}
      </h2>
      <EditJobForm
        job={job}
        onUpdateJob={handleUpdateJob}
        onCancelChange={onCancelChange}
        onClose={onClose}
        error={error}
      />
    </FullBlockingModal>
  );
};

export default EditJobModal;
